import { UPDATE_USER_STATUS } from '../../actions/update-user-status';

const initialState = {
    active: false,
    subscriptions: null,
    userBlocked: false
}

export const userStatus = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_USER_STATUS:
            return Object.assign({}, state, {
                active: action.status.active,
                subscriptions: action.status.subscriptions,
                userBlocked: action.status.userBlocked
            })
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/user/status.js